module.exports = "https://static.energy5.com/_next/static/images/slide2-6d08632b4352246f635bad483e2f11d9.png";